import { useMutation, useQueryClient } from 'react-query'
import { useParams } from 'react-router-dom'
import { DEFAULT_LANGUAGE_CODE } from 'src/components/languages/langauges-list/constants'
import { QUERY_KEYS } from 'src/constants'

import { accountsService } from 'src/services/accounts.service'
import { IAccountByIdRespDto } from 'src/types'

export const useRemintAccountToken = (locale: string = DEFAULT_LANGUAGE_CODE) => {
  const { accountId } = useParams()
  const queryClient = useQueryClient()

  return useMutation(
    async () => (accountId ? await accountsService.remintAccountToken(accountId) : null),
    {
      onSuccess(data) {
        if (!data) return

        queryClient.setQueryData(
          [QUERY_KEYS.ACCOUNT, accountId, locale],
          (prev?: IAccountByIdRespDto) =>
            prev ? { ...prev, is_minting: true } : ({} as IAccountByIdRespDto),
        )
      },
    },
  )
}
